import { render, staticRenderFns } from "./memberList.vue?vue&type=template&id=8bd874ea"
import script from "./memberList.vue?vue&type=script&lang=js"
export * from "./memberList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports